/* ==========================================================================
   AKRO - Quick add to cart des vignettes produit
   --------------------------------------------------------------------------
   Va avec snippets/akro-quick-add.liquid et assets/akro-quick-add.css.
   Charge en `defer` depuis layout/theme.liquid.

   CE QUE CE FICHIER NE FAIT PAS : l'ajout au panier lui-meme. Il se contente
   d'ecrire la variante choisie dans le formulaire et de le soumettre. Tout le
   reste - appel `/cart/add`, rendu des sections, evenements panier, ouverture
   du tiroir - est pris en charge par le composant Alpine `ProductForm` du
   theme, exactement comme sur la fiche produit. C'est le seul moyen d'avoir
   la garantie d'un comportement identique aux boutons existants.

   TOUT EST DELEGUE SUR `document`, EN PHASE DE CAPTURE
   - Delegation : les grilles sont re-rendues par le theme (filtres, editeur,
     recherche). Aucun ecouteur n'est pose sur une vignette, donc rien a
     reattacher et rien a nettoyer apres un re-rendu.
   - Capture : layout/theme.liquid pose un ecouteur de clic sur `document` qui
     detourne TOUT lien contenant `/products/` pour un envoi GTM suivi d'une
     navigation. Nos commandes sont des <button>, il ne les voit donc pas ;
     mais la capture nous laisse de toute facon la main en premier, et l'on
     coupe la propagation des seuls clics qui nous appartiennent.

   ETATS, PORTES PAR data-state SUR `.akro-qa`
     idle    - au repos
     sizes   - le panneau de tailles est ouvert
     loading - envoi en cours
     done    - ajoute (le tiroir s'ouvre tout seul)
     error   - Shopify a refuse l'ajout
   ========================================================================== */

(function () {
  'use strict';

  var SEL_ROOT = '.akro-qa';
  var DONE_MS = 1500;
  /* Filet de securite : si aucun evenement ne revient (reseau coupe), on rend
     la main au bout de ce delai plutot que de laisser un bouton inerte. */
  var TIMEOUT_MS = 12000;

  /* ---------------------------------------------------------------- outils */

  function root(el) {
    return el && el.closest ? el.closest(SEL_ROOT) : null;
  }

  function setState(qa, state) {
    if (!qa) return;
    qa.setAttribute('data-state', state);
    var open = state === 'sizes';
    var openers = qa.querySelectorAll('[data-akro-qa-open][aria-expanded]');
    for (var i = 0; i < openers.length; i++) {
      openers[i].setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    var panel = qa.querySelector('[data-akro-qa-sizes]');
    if (panel) {
      /* `inert` plutot que `visibility: hidden` : il retire le panneau ferme
         du parcours clavier et des lecteurs d'ecran SANS empecher la barre
         voisine de recevoir le focus - voir le commentaire de la feuille de
         styles. Repli propre sur les navigateurs sans `inert` : le panneau
         reste focusable mais `pointer-events: none` l'empeche deja d'avaler
         le moindre clic. */
      if (open) panel.removeAttribute('inert');
      else panel.setAttribute('inert', '');
    }
  }

  function closePanels(except) {
    var open = document.querySelectorAll(SEL_ROOT + '[data-state="sizes"]');
    for (var i = 0; i < open.length; i++) {
      if (open[i] !== except) setState(open[i], 'idle');
    }
  }

  /* Sur desktop, un panneau ouvert doit se refermer des que la souris quitte
     la carte. Ecouteur pose a l'ouverture et retire de lui-meme : un seul a
     la fois, aucune fuite si la grille est re-rendue entre-temps. */
  function armMouseLeave(qa) {
    var tile = qa.closest('.akro-tile');
    if (!tile) return;
    var off = function () {
      tile.removeEventListener('mouseleave', off);
      if (qa.getAttribute('data-state') === 'sizes') setState(qa, 'idle');
    };
    tile.addEventListener('mouseleave', off);
  }

  function submit(qa, variantId) {
    if (!qa) return;
    if (qa.getAttribute('data-state') === 'loading') return;

    var form = qa.querySelector('form');
    var input = qa.querySelector('[data-akro-qa-id]');
    if (!form || !input) return;

    if (variantId) input.value = variantId;
    if (!input.value) return;

    setState(qa, 'loading');

    /* Garde-fou : si rien ne repond, on revient a l'etat de depart. */
    window.clearTimeout(qa._akroTimer);
    qa._akroTimer = window.setTimeout(function () {
      if (qa.getAttribute('data-state') === 'loading') setState(qa, 'idle');
    }, TIMEOUT_MS);

    /* `requestSubmit` declenche bien l'evenement `submit` - contrairement a
       `form.submit()`, qui l'ignore et provoquerait un POST plein page vers
       /cart. C'est LE point a ne jamais toucher : le panier ne doit jamais
       s'ouvrir en pleine page. */
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      var ev = new Event('submit', { bubbles: true, cancelable: true });
      if (form.dispatchEvent(ev)) {
        /* Aucun gestionnaire n'a annule : plutot que de laisser partir la
           navigation, on abandonne proprement. */
        setState(qa, 'idle');
      }
    }
  }

  function showError(qa, message) {
    window.clearTimeout(qa._akroTimer);
    var box = qa.querySelector('[data-akro-qa-feedback]');
    if (box) {
      box.textContent =
        message ||
        (window.theme && window.theme.strings && window.theme.strings.cartError) ||
        '';
    }
    setState(qa, 'error');
    qa._akroTimer = window.setTimeout(function () {
      if (qa.getAttribute('data-state') === 'error') setState(qa, 'idle');
    }, 4000);
  }

  function showDone(qa) {
    window.clearTimeout(qa._akroTimer);
    setState(qa, 'done');
    qa._akroTimer = window.setTimeout(function () {
      if (qa.getAttribute('data-state') === 'done') setState(qa, 'idle');
    }, DONE_MS);
  }

  /* ----------------------------------------------------------------- clics */

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      /* 1. Ouvrir : pastille mobile ou barre desktop. */
      var opener = target.closest('[data-akro-qa-open]');
      if (opener) {
        var qaOpen = root(opener);
        if (!qaOpen) return;

        event.preventDefault();
        event.stopPropagation();

        var state = qaOpen.getAttribute('data-state');
        if (state === 'loading') return;

        if (qaOpen.hasAttribute('data-akro-qa-single')) {
          /* Une seule variante achetable (kit, accessoire, perimetre
             travel-size) : on ajoute directement, sans etape de choix. */
          closePanels();
          submit(qaOpen);
          return;
        }

        if (state === 'sizes') {
          setState(qaOpen, 'idle');
          /* Uniquement au clavier : a la souris, rendre le focus laisserait
             une carte « active » alors que le curseur est deja ailleurs. */
          if (event.detail === 0) opener.focus();
        } else {
          closePanels(qaOpen);
          setState(qaOpen, 'sizes');
          armMouseLeave(qaOpen);

          /* AU CLAVIER, LE FOCUS DOIT SUIVRE. Sans cela le parcours casse :
             la barre passe en `visibility: hidden` pour laisser la place au
             panneau, le navigateur retire donc le focus du bouton, `:focus-within`
             retombe et le panneau - qui n'est visible qu'au survol ou au focus -
             se referme aussitot. On deplace le focus sur la premiere taille.
             `event.detail === 0` distingue une activation clavier (Entree,
             Espace) d'un vrai clic souris, ou l'on ne veut rien deplacer. */
          if (event.detail === 0) {
            var firstChip = qaOpen.querySelector('[data-akro-qa-add]');
            /* Au tick suivant : `inert` vient d'etre retire, le navigateur doit
               avoir repris en compte la focusabilite avant qu'on deplace le
               focus. Pose sur un timer et non sur rAF, qui ne se declenche pas
               dans un onglet non rendu. */
            if (firstChip) window.setTimeout(function () { firstChip.focus(); }, 0);
          }
        }
        return;
      }

      /* 2. Choisir une taille. */
      var chip = target.closest('[data-akro-qa-add]');
      if (chip) {
        event.preventDefault();
        event.stopPropagation();
        submit(root(chip), chip.getAttribute('data-variant-id'));
        return;
      }

      /* 3. Clic ailleurs : on referme ce qui est ouvert. Un clic tombe DANS
         la carte dont le panneau est ouvert est avale - on ferme, on ne part
         pas sur la fiche produit dans la foulee. Un clic hors de la carte
         laisse passer, pour ne rien bloquer de la navigation. */
      var open = document.querySelectorAll(SEL_ROOT + '[data-state="sizes"]');
      for (var i = 0; i < open.length; i++) {
        var qa = open[i];
        setState(qa, 'idle');
        var tile = qa.closest('.akro-tile');
        if (tile && tile.contains(target)) {
          event.preventDefault();
          event.stopPropagation();
        }
      }
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Escape' && event.key !== 'Esc') return;
      var open = document.querySelectorAll(SEL_ROOT + '[data-state="sizes"]');
      if (!open.length) return;
      for (var i = 0; i < open.length; i++) {
        var qa = open[i];
        var hadFocus = qa.contains(document.activeElement);
        setState(qa, 'idle');
        /* Le focus etait dans le panneau que l'on vient de fermer : on le
           ramene sur le bouton qui l'avait ouvert, jamais en debut de page. */
        if (hadFocus) {
          var back =
            qa.querySelector('.akro-qa__cta[aria-expanded]') ||
            qa.querySelector('[data-akro-qa-open]');
          if (back) back.focus();
        }
      }
    },
    true
  );

  /* ---------------------------------------------- retours du formulaire */

  /* Les trois evenements du composant `ProductForm` remontent depuis l'ile.
     Ecoute en capture : on est ainsi insensible a tout `stopPropagation`
     pose entre la vignette et `document`. */
  function bindFormEvent(name, handler) {
    document.addEventListener(
      name,
      function (event) {
        var qa = root(event.target);
        if (qa) handler(qa, event);
      },
      true
    );
  }

  bindFormEvent('baseline:productform:loading', function (qa) {
    setState(qa, 'loading');
  });

  bindFormEvent('baseline:productform:success', function (qa) {
    showDone(qa);
  });

  bindFormEvent('baseline:productform:error', function (qa, event) {
    showError(qa, event.detail && event.detail.message);
  });

  /* Filet pour la fenetre d'avant hydratation : tant que l'ile n'est pas
     `ready`, c'est le script de secours de layout/theme.liquid qui poste, et
     lui n'emet que `baseline:cart:afteradditem`. On rattache le retour au bon
     bouton par l'identifiant du formulaire. */
  document.addEventListener(
    'baseline:cart:afteradditem',
    function (event) {
      var sourceId = event.detail && event.detail.sourceId;
      if (!sourceId || sourceId.indexOf('akro-qa-') !== 0) return;
      var form = document.getElementById(sourceId);
      var qa = root(form);
      if (qa && qa.getAttribute('data-state') !== 'done') showDone(qa);
    },
    true
  );

  /* ------------------------------------------- carrousel mobile : reperes */

  /* Le `scroll` ne remonte pas dans l'arbre : ecoute en capture sur
     `document`, ce qui couvre aussi les rails ajoutes apres coup par un
     re-rendu de section. Passif : on ne bloque jamais le defilement. */
  document.addEventListener(
    'scroll',
    function (event) {
      var rail = event.target;
      if (!rail || rail.nodeType !== 1 || !rail.hasAttribute) return;
      if (!rail.hasAttribute('data-akro-rail')) return;

      var width = rail.clientWidth;
      if (!width) return;

      var index = Math.round(rail.scrollLeft / width);
      /* On n'ecrit que si l'indice change : deux ecritures par balayage au
         lieu d'une par evenement, donc aucun recalcul de style en rafale. */
      if (rail._akroIndex === index) return;
      rail._akroIndex = index;

      var media = rail.parentNode;
      var bar = media && media.querySelector('.akro-tile__progress');
      if (bar) bar.style.setProperty('--akro-slide', String(index));
    },
    true
  );
})();
